module.exports = new __parcel__URL__("shop_battle_pass_image.03893e2f.png").toString();